<template>
  <div id="page-order-list">
    <div class="vx-card p-6">
      <div class="mb-6">
        <vs-button
          v-if="$acl.check('admin')"
          @click="add"
          color="primary"
          type="border"
          icon="add"
          >{{ $t("Order.New") }}</vs-button
        >
      </div>
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :show-borders="false"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :ref="gridRefKey"
          @row-click="gotoDetails"
        >
          >
          <dx-state-storing
            :enabled="true"
            type="custom"
            :custom-load="loadState"
            :custom-save="saveState"
            :storage-key="storageKey"
          />
          <dx-paging :page-size="20" />
          <dx-pager :show-page-size-selector="false" :show-info="true" />
          <dx-filter-row :visible="true" />
          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="90"
            :visible="false"
          />

          <dx-column
            data-field="created"
            :caption="$t('Order.OrderDate')"
            :width="200"
            data-type="date"
            format="shortDate"
          />
          <dx-column
            data-field="state"
            :caption="$t('Order.State')"
            :hiding-priority="7"
            width="200"
            data-type="text"
          >
            <dx-lookup
              display-expr="description"
              value-expr="id"
              :data-source="orderStates"
            />
          </dx-column>
          <dx-column
            data-field="description"
            :caption="$t('Order.Description')"
            :width="200"
          />
          <dx-column
            data-field="amountGross"
            :caption="$t('Order.Amount')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />
          <dx-column
            data-field="amountVat"
            :caption="$t('Order.AmountVAT')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />
          <dx-column
            data-field="amountTotal"
            :caption="$t('Order.OrderTotal')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />
          <dx-column
            data-field="customerReference"
            :caption="$t('Order.CustomerReference')"
            :width="200"
          />
          <dx-column />
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleOrderManagement from '@/store/order-management/moduleOrderManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import { notifyMixin } from '@/mixins/notifyMixin'
import { DxItem } from 'devextreme-vue/form'
// import OrderUserList from './OrderUserList.vue'
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxStateStoring,
  DxEditing,
  DxPosition,
  DxForm,
  DxLookup,
  DxPopup as DxGridPopup
} from 'devextreme-vue/data-grid'

const gridRefKey = "grid-orders"
let _this = {}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxStateStoring,
    DxEditing,
    DxPosition,
    DxForm,
    DxItem,
    DxLookup,
    DxGridPopup
    // OrderUserList
  },
  mixins: [notifyMixin],
  data () {
    const orderStates = this.$store.state.refCodes.orderStates.map(a => {
      return { ...a, description: this.$t(`OrderState.${a.description}`) }
    })
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store.dispatch('orderManagement/fetchOrders', { idOrganisation: _this.activeOrganisation.id })
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    console.log(orderStates)
    return {
      customDataSource,
      gridRefKey,
      storageKey: 'dx_datagrid_gridOrder_4',
      restoreFullGridState: false,
      defaultOrder: null,
      editTitle: "",
      orderStates
    }
  },
  watch: {
    activeOrganisation: function () {
      this.refreshGrid()
    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"])
  },
  methods: {
    refreshGrid () {
      console.log(`refreshing grid ${this.$refs[gridRefKey]}`)
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    },
    gotoDetails (e) {
      if (e.rowType === 'data') {
        const grid = this.$refs[gridRefKey].instance
        grid.selectRows([e.key], false)
        localStorage[this.storageKey] = JSON.stringify(grid.state())
        this.$router.push(`/order/view/${e.key}`).catch(() => { })
      }
    },
    loadState () {
      const storage = localStorage[this.storageKey]
      if (storage) {
        const state = JSON.parse(storage)
        if (this.restoreFullGridState) {
          return state
        } else {
          const res = {
            columns: state.columns,
            pageSize: state.pageSize
          }
          for (let i = 0; i < res.columns.length; i++) {
            delete res.columns[i].filterValue
          }
          return res
        }
      }
    },
    saveState (state) {
      localStorage[this.storageKey] = JSON.stringify(state)
    },
    add () {
      this.$router.push("/order/new")
    },
  },
  mounted () {
  },
  created () {
    _this = this
    this.restoreFullGridState = this.$route.query.initial !== "true"
    if (!moduleOrderManagement.isRegistered) {
      this.$store.registerModule(
        'orderManagement',
        moduleOrderManagement
      )
      moduleOrderManagement.isRegistered = true
    }
  }
}
</script>

